import { Text } from '@chakra-ui/react';
import RoutableModal from 'components/general/RoutableModal';
import { useClientCreateMutation } from 'generated/graphql';
import { FormProvider, useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import ClientForm from '../ClientForm';
import { updateCacheOnCreate } from './lib';

type FormData = {
  firstName: string;
  lastName: string;
  email: string;
  leaseApplication: boolean;
};

function NewClient() {
  const navigate = useNavigate();
  const goBack = () => navigate('..');
  const form = useForm<FormData>({ defaultValues: { leaseApplication: true } });
  const [createClient, { loading }] = useClientCreateMutation({
    update: updateCacheOnCreate,
    onCompleted: goBack,
  });

  const handleSubmit = form.handleSubmit(({ leaseApplication, ...data }) =>
    createClient({ variables: { data, options: { skipLeaseApplication: !leaseApplication } } })
  );

  return (
    <RoutableModal
      title="New Client"
      buttons={{ action: { text: 'Save', handler: handleSubmit } }}
      loading={loading}
    >
      <Text mb={10}>
        Please enter the required information to add a client and send them a new lease application
      </Text>
      <FormProvider {...form}>
        <ClientForm />
      </FormProvider>
    </RoutableModal>
  );
}

export default NewClient;
